import * as React from "react";

import { Box, Link, Typography } from "@material-ui/core";

import { Translate } from "client/utils/internationalization";

import { useStyles } from "./styles";
import { FAQ } from "./types";

export const getYourBusinessDetailsFaqs = (
  t: Translate,
  classes: ReturnType<typeof useStyles>
): FAQ[] => [
  {
    question: t("uiFaqBusinessDetailsDontKnowNzbnQuestion"),
    answer: (
      <Box>
        <Typography className={classes.paragraph} variant="body2">
          {t("uiFaqBusinessDetailsDontKnowNzbnAnswer1")}
          <Link
            href={t("uiFaqBusinessDetailsDontKnowNzbnUrl")}
            target="_blank"
            rel="noopener noreferrer"
          >
            {t("uiFaqBusinessDetailsDontKnowNzbnLinkText")}
          </Link>
          {t("uiFaqBusinessDetailsDontKnowNzbnAnswer2")}
        </Typography>
      </Box>
    ),
  },
  {
    question: t("uiFaqBusinessDetailsCertifiedId"),
    answer: (
      <Box>
        <Typography className={classes.paragraph} variant="body2">
          {t("uiFaqBusinessDetailsCertifiedIdAnswer1")}
        </Typography>
        <Typography className={classes.paragraph} variant="body2">
          {t("uiFaqBusinessDetailsCertifiedIdAnswer2")}
          <ul>
            <li>lawyer</li>
            <li>chartered accountant</li>
            <li>justice of the peace</li>
            <li>medical doctor</li>
            <li>registered teacher</li>
            <li>member of the police</li>
          </ul>
        </Typography>
        <Typography className={classes.paragraph} variant="body2">
          {t("uiFaqBusinessDetailsCertifiedIdAnswer3")}
        </Typography>
        <Typography className={classes.paragraph} variant="body2">
          {t("uiFaqBusinessDetailsCertifiedIdAnswer4")}
        </Typography>
      </Box>
    ),
  },
  {
    question: t("uiFaqBusinessDetailsWhatIfIDontHaveWebsiteQuestion"),
    answer: (
      <Box>
        <Typography className={classes.paragraph} variant="body2">
          {t("uiFaqBusinessDetailsWhatIfIDontHaveWebsiteAnswer1")}
        </Typography>
        <Typography className={classes.paragraph} variant="body2">
          {t("uiFaqBusinessDetailsWhatIfIDontHaveWebsiteAnswer2")}
          <Link
            href={t("uiFaqBusinessDetailsWhatIfIDontHaveWebsiteUrl")}
            rel="noopener noreferrer"
            target="_blank"
          >
            {t("uiFaqBusinessDetailsWhatIfIDontHaveWebsiteLinkText")}
          </Link>
        </Typography>
      </Box>
    ),
  },
  {
    question: t("uiFaqBusinessDetailsDontKnowAuQuestion"),
    answer: (
      <Box>
        <Typography className={classes.paragraph} variant="body2">
          {t("uiFaqBusinessDetailsDontKnowAuAnswer1")}
          <Link
            href={t("uiFaqBusinessDetailsDontKnowAuUrl")}
            rel="noopener noreferrer"
            target="_blank"
          >
            {t("uiFaqBusinessDetailsDontKnowAuLinkText")}
          </Link>
          {t("uiFaqBusinessDetailsDontKnowAuAnswer2")}
        </Typography>
      </Box>
    ),
  },
  {
    question: t("uiFaqBusinessDetailsControllerQuestion"),
    answer: (
      <Box>
        <Typography className={classes.paragraph} variant="body2">
          {t("uiFaqBusinessDetailsControllerAnswer1")}
        </Typography>
        <Typography className={classes.paragraph} variant="body2">
          {t("uiFaqBusinessDetailsControllerAnswer2")}
        </Typography>
        <ul>
          <li>owner</li>
          <li>founder</li>
          <li>CEO</li>
          <li>COO</li>
          <li>director</li>
          <li>accountant</li>
        </ul>
        <Typography className={classes.paragraph} variant="body2">
          {t("uiFaqBusinessDetailsMultipleStoresAnswer3")}
        </Typography>
        <Typography className={classes.paragraph} variant="body2">
          {t("uiFaqBusinessDetailsMultipleStoresAnswer4")}
        </Typography>
      </Box>
    ),
  },
  {
    question: t("uiFaqBusinessDetailsMultipleStoresQuestion"),
    answer: (
      <Box>
        <Typography className={classes.paragraph} variant="body2">
          {t("uiFaqBusinessDetailsMultipleStoresAnswer1")}
          <Link
            href={t("uiFaqBusinessDetailsMultipleStoresLinkUrl")}
            target="_blank"
            rel="noopener noreferrer"
          >
            {t("uiFaqBusinessDetailsMultipleStoresLinkText")}
          </Link>
        </Typography>
      </Box>
    ),
  },
];
